// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import {CloseOutlined} from "@ant-design/icons";
import {Button, ConfigProvider} from "antd";
import i18next from "i18next";

export default function CookieConsent({logo, logoAlt, onAccept}) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#1677FF",
          borderRadius: 6,
        },
      }}
    >
      <div className="cookie-consent-banner">
        {logo ? (
          <img className="cookie-consent-logo" src={logo} alt={logoAlt || ""} />
        ) : null}
        <div className="cookie-consent-text">
          {i18next.t("modification:Cookie Banner")}
        </div>
        <div className="cookie-consent-actions">
          <Button
            className="cookie-consent-btn-close"
            icon={<CloseOutlined />}
            aria-label={i18next.t("general:Close")}
            onClick={onAccept}
          />
          <Button type="primary" className="cookie-consent-btn-accept" onClick={onAccept}>
            {i18next.t("modification:Accept all Cookies")}
          </Button>
        </div>
      </div>
    </ConfigProvider>
  );
}
